var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filters-container"},[_c('div',{staticClass:"placeholder"}),_vm._l((_vm.filterColumns),function(column){return _c('PurchasesTreeTableFilterItem',{key:column.field,attrs:{"field":column.field,"type":column.type,"filter-path":column.filterPath,"operation":column.operation,"width":column.width}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }